module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAMAAADTXB33AAAATlBMVEUAAAD6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYlYGVkkAAAAGXRSTlMA6gbdLeK89NZnXjMhDvCxqcuzjlwoFAHAY7TuuwAAAJZJREFUKM91zlkShCAMRdFHQAQF56Gz/402rW05kfNF1a2QICFvG1ZDRQBNg+LGesKm1rxzxjje6XorJR/KyzM10pylCZ4FHlZKHzRSUmARCnmqlVKLSkoVSPixIGCShpIuv+kn6nfREZugXocH/Bn1KAY4m1CSubicPeMmuKO4gIel30u/4CVaTmxEBnXMHSFrHccVpy9VMShrQrF0lgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_black/love.png
// module id = mh0x
// module chunks = 1